<template>
  <div id="" class="">
      <el-dialog title="选择优惠券" :visible.sync="isShowdialog" :before-close="beforeClose" width="60%" top="5%">
        <div id="attendance_record" class="daochu">
            <common-search :searchList="searchList" @onSearch="onSearch" ></common-search>

            <common-table
              :product_list="product_list"
              :loading="loading"
              @sort-change="sortChange"
              @data-change="getMessageByPage"
              storageName="checkedHeaders_coupon"
              title="请点击想要选择的数据列后点击确定"
              type="coupon"
              :highlight="true"
              @current-change="selectItem"
              height="450"
              :tableHandler="tableHandler"
              :newCheckHeader="checkedHeaders"
              ></common-table>

            <div style="text-align: right;margin-top:10px">
               <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="pageSizes"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
              </el-pagination>
            </div>

            <div style="display: flex;justify-content: flex-end;margin-top: 20px">
              <el-button type="primary" @click="selectProduct">确定</el-button>
              <el-button @click="beforeClose">取消</el-button>
            </div>

        </div>
      </el-dialog>
  </div>
</template>
<script>
export default {
  props:['dialogVisible','otype'],
  watch: {
    dialogVisible(val){
      this.isShowdialog = val;
      if(val){
        this.getMessageByPage();
      }
    }
  },
  data() {
    return {
      isShowdialog: false,
      loading: false,
      product_list: null,
      machineNO: '',
      name: '',
      verificationValidDate:[],
      currentPage: 1,
      total: 0,
      pageSizes: [10, 20, 50],
      pageSize: 10,
      product: {},
      searchList: {
        couponName: '',
      },
      tableHandler: [
        // 'show',
      ],
      newSearchList: null,
      checkedHeaders: ['优惠券名称', '优惠金额','使用条件','有效天数'],
    }
  },
  methods:{
    cancel(){
      this.$refs.record_table.setCurrentRow();
    },

    beforeClose(done){
      this.product = {};
      this.isShowdialog = false;
      this.$emit('change-state',{isShow: this.isShowDialog,dialog:'coupon'});
    },

    async getMessageByPage(){
      this.loading = true;
      let _searchList = this.newSearchList ? this.newSearchList : this.searchList
      let options = this.$util.formatOptions(_searchList);
      if(this.$util.isEmpty(this.order))
        this.order = "default";

      const product_list = await this.$request.get_message('coupons',{page: this.currentPage,limit: this.pageSize,query: options});
      //console.log(product_list);
      if(product_list.code === 0){
        this.product_list = product_list.data;
        this.total = product_list.total;
      }else{
        this.$message(product_list['errMsg'])
      }
      this.loading = false;
    },

    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.getMessageByPage();
    },

    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getMessageByPage();
    },

    selectItem(product){
      //console.log(product);
      if(!this.$util.isEmpty(product)){
        this.product = product;
      }
    },

    selectProduct(){
      this.isShowdialog = false;
      this.$emit('change-state',{isShow: this.isShowDialog,dialog:'coupon',data: this.product});
    },

    onSearch(val){
      this.$commondata.searchObj = this.searchList;
      this.newSearchList = Object.assign({}, this.searchList);
      if(val.price !== ''){
        this.newSearchList.price = val.price;
      }
      if(val.stock !== ''){
        this.newSearchList.stock = val.stock;
      }
      this.getMessageByPage();
    },

    sortChange(val){
      this.order = val.order;
      this.getMessageByPage();
    },
  },
}
</script>

<style type="text/css">

</style>



// WEBPACK FOOTER //
// src/components/dialog/selectCouponDialog.vue